<template>
  <div class="mx-3">
    <v-container fill-height fluid class="px-0">
      <v-row no-gutters>
        <v-col cols="12" md="4">
          <v-card
            dark
            :height="getHeight()"
            class="elevation-0 px-8 pt-11 box text-center hover"
            style="margin-bottom: 3px; margin-right: 1px"
            color="#1a5276"
            @click="$router.push('/forms/hr/')"
          >
            <v-icon style="font-size: 70px" dark>people</v-icon>
            <h2
              class="text-center box-head mt-3"
              style="border-bottom: 1px solid #fff"
            >
              Connect with Human Resources
            </h2>

            <v-card-text
              class="px-2 mt-1 font-weight-light box-text text-center"
            >
              <span style="font-size: 16px"
                >Have questions for ICJIA HR? Click to connect!</span
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            dark
            :height="getHeight()"
            class="elevation-0 px-8 pt-11 box text-center hover"
            style="margin-bottom: 3px; margin-right: 1px"
            color="#1a5276"
            @click="$router.push('/forms/conference/')"
          >
            <v-icon style="font-size: 70px" dark>group_work</v-icon>
            <h2
              class="text-center box-head mt-3"
              style="border-bottom: 1px solid #fff"
            >
              Reserve a Conference Room
            </h2>

            <v-card-text
              class="px-2 mt-1 font-weight-light box-text text-center"
            >
              <span style="font-size: 16px"
                >Need a conference room? Click here and reserve it.</span
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            dark
            :height="getHeight()"
            class="elevation-0 px-8 pt-11 box text-center hover"
            style="margin-bottom: 3px"
            color="#1a5276"
            @click="$router.push('/forms/support/')"
          >
            <div class="text-center">
              <v-icon style="font-size: 70px" dark>devices</v-icon>
            </div>
            <h2
              class="text-center box-head mt-3"
              style="border-bottom: 1px solid #fff"
            >
              Contact Technical Support
            </h2>

            <v-card-text
              class="px-2 mt-1 font-weight-light box-text text-center"
            >
              <span style="font-size: 16px"
                >Locked out of email? Have a computer issue? Click here to
                contact ICJIA technical support.</span
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Boxes: {{ boxes }} -->
  </div>
</template>

<script>
export default {
  computed: {
    getBoxSize() {
      return 12 / this.boxes.length;
    },
  },
  methods: {
    getHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 300;
      } else {
        return 300;
      }
    },

    routeToURL(box) {
      if (!box.url) return null;
      const checkDomain = function (url) {
        if (url.indexOf("//") === 0) {
          url = location.protocol + url;
        }
        return url
          .toLowerCase()
          .replace(/([a-z])?:\/\//, "$1")
          .split("/")[0];
      };

      const isExternal = function (url) {
        return (
          (url.indexOf(":") > -1 || url.indexOf("//") > -1) &&
          checkDomain(location.href) !== checkDomain(url)
        );
      };
      if (isExternal(box.url)) {
        window.open(box.url, "noopener,resizable,scrollbars").focus();
      } else {
        this.$router.push(box.url);
      }
    },
    getFeatureBoxColor(index) {
      return this.colors[index];
    },
  },
  data() {
    return {
      // colors: ["#0E4471", "#0E4471", "#0E4471", "#0E4471"],
    };
  },
  props: {
    boxes: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
}
.box:hover {
  background: #ccc !important;
}
.box:hover > * {
  color: #000 !important;
  cursor: pointer;
}
.box-head {
  font-size: 28px;
  text-transform: uppercase;
  color: #fff;
  font-weight: 900;
}
.box-text {
  font-size: 18px;
  margin-top: 8px;
  color: #fff;
}
.box-text:hover {
  color: #000 !important;
}
.rule {
  border-bottom: 1px solid #ccc !important;
  border-top: 1px solid #ccc !important;
}

.v-sheet.v-card {
  border-radius: 0px;
}

.mr1 {
  margin-right: 2px;
}

.ml1 {
  margin-left: 2px;
}
</style>
